import { CheckHomeworkPage } from "@/pages/teacher/CheckHomeworkPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/check/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <CheckHomeworkPage />;
}
